import { Reducer } from "redux";

import {
  WoundCareDisciplineActionDispatchTypes,
  DisciplineRecord,
} from "../constants/Discipline";
import { DisciplineResponse } from "../models/Api/Discipline";
import { WoundCareDisciplineDispatchTypes } from "../models/DispatchTypes/Discipline";

export const initialPostState: DisciplineResponse = {
  loading: false,
  response: {
    totalRows: 0,
    disciplineList: [DisciplineRecord],
  },
};

const WoundCareDisciplineReducer: Reducer<
  DisciplineResponse,
  WoundCareDisciplineDispatchTypes
> = (state = initialPostState, action) => {
  switch (action.type) {
    case WoundCareDisciplineActionDispatchTypes.GET_WOUND_CARE_DISCIPLINE_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case WoundCareDisciplineActionDispatchTypes.GET_WOUND_CARE_DISCIPLINE_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case WoundCareDisciplineActionDispatchTypes.GET_WOUND_CARE_DISCIPLINE_RESET: {
      return initialPostState;
    }
  }
  return state;
};

export default WoundCareDisciplineReducer;
